import error from '../../../../common/nodejs/errors';

/** 各フェーズ定義 */
export const PHASE = {
  /** 待機 */
  WAIT: 'wait',
  /** 実行(RLフルード交換/エア抜き) */
  RL_EXE: 'rlExe',
  /** 実行監視(RLフルード交換/エア抜き) */
  RL_MONITOR: 'rlMonitor',
  /** 実行(RRフルード交換/エア抜き) */
  RR_EXE: 'rrExe',
  /** 実行監視(RRフルード交換/エア抜き) */
  RR_MONITOR: 'rrMonitor',
  /** 実行(エア混入確認) */
  AIR_EXE: 'airExe',
  /** 実行監視(エア混入確認) */
  AIR_MONITOR: 'airMonitor',
  /** 実行監視(TMC Test) */
  TMC_MONITOR: 'tmcMonitor',
  /** 実行(パイプ接続確認) */
  PIPE_EXE: 'pipeExe',
  /** 実行監視(パイプ接続確認) */
  PIPE_MONITOR: 'pipeMonitor',
  /** 停止 */
  STOP: 'stop',
  /** 実行条件不成立表示 */
  EXECUTION_CONDITION_ERROR: 'executionConditionError',
  /** 開始不可表示 */
  START_ERROR: 'startError',
  /** フルード交換/エア抜き失敗表示 */
  AIR_BLEEDING_ERROR: 'airBleedingError',
  /** エア混入/フルード漏れテスト失敗表示 */
  TEST_ERROR: 'testError',
  /** ブレーキ異常表示 */
  BRAKE_ERROR: 'brakeError',
  /** パイプ異常表示 */
  PIPE_ERROR: 'pipeError',
  /** 共通エラー */
  FAILED: 'failed',
};

/** ダイアログのヘッダー色 */
const HEADER_COLORS = {
  /** エラー */
  DANGER: 'danger',
  /** 成功 */
  SUCCESS: 'success',
  /** 確認・実行中 */
  SECONDARY: 'secondary'
};

/** ダイアログのヘッダータイトル */
const HEADER_TITLES = {
  /** 確認 */
  CONFIRMATION: 'message.common_title_confirmation',
  /** 実行中 */
  EXECUTION: 'individual.common_title_execution',
  /** 成功 */
  SUCCESS: 'message.common_title_success',
  /** エラー */
  ERROR: 'message.common_title_error'
};

/** ヘッダー色・タイトルの phase ごとの情報 */
export const HEADER_PHASE_INFO = {
  [PHASE.WAIT]: {
    headerColor: HEADER_COLORS.SECONDARY,
    headerTitle: HEADER_TITLES.CONFIRMATION
  },
  [PHASE.RL_EXE]: {
    headerColor: HEADER_COLORS.SECONDARY,
    headerTitle: HEADER_TITLES.CONFIRMATION
  },
  [PHASE.RL_MONITOR]: {
    headerColor: HEADER_COLORS.SECONDARY,
    headerTitle: HEADER_TITLES.EXECUTION
  },
  [PHASE.RR_EXE]: {
    headerColor: HEADER_COLORS.SECONDARY,
    headerTitle: HEADER_TITLES.CONFIRMATION
  },
  [PHASE.RR_MONITOR]: {
    headerColor: HEADER_COLORS.SECONDARY,
    headerTitle: HEADER_TITLES.EXECUTION
  },
  [PHASE.AIR_EXE]: {
    headerColor: HEADER_COLORS.SECONDARY,
    headerTitle: HEADER_TITLES.CONFIRMATION
  },
  [PHASE.AIR_MONITOR]: {
    headerColor: HEADER_COLORS.SECONDARY,
    headerTitle: HEADER_TITLES.EXECUTION
  },
  [PHASE.TMC_MONITOR]: {
    headerColor: HEADER_COLORS.SECONDARY,
    headerTitle: HEADER_TITLES.EXECUTION
  },
  [PHASE.PIPE_EXE]: {
    headerColor: HEADER_COLORS.SECONDARY,
    headerTitle: HEADER_TITLES.CONFIRMATION
  },
  [PHASE.PIPE_MONITOR]: {
    headerColor: HEADER_COLORS.SECONDARY,
    headerTitle: HEADER_TITLES.EXECUTION
  },
  [PHASE.STOP]: {
    headerColor: HEADER_COLORS.SUCCESS,
    headerTitle: HEADER_TITLES.SUCCESS
  },
  [PHASE.EXECUTION_CONDITION_ERROR]: {
    headerColor: HEADER_COLORS.DANGER,
    headerTitle: HEADER_TITLES.ERROR
  },
  [PHASE.START_ERROR]: {
    headerColor: HEADER_COLORS.DANGER,
    headerTitle: HEADER_TITLES.ERROR
  },
  [PHASE.AIR_BLEEDING_ERROR]: {
    headerColor: HEADER_COLORS.DANGER,
    headerTitle: HEADER_TITLES.ERROR
  },
  [PHASE.TEST_ERROR]: {
    headerColor: HEADER_COLORS.DANGER,
    headerTitle: HEADER_TITLES.ERROR
  },
  [PHASE.BRAKE_ERROR]: {
    headerColor: HEADER_COLORS.DANGER,
    headerTitle: HEADER_TITLES.ERROR
  },
  [PHASE.PIPE_ERROR]: {
    headerColor: HEADER_COLORS.DANGER,
    headerTitle: HEADER_TITLES.ERROR
  },
  [PHASE.FAILED]: {
    headerColor: HEADER_COLORS.DANGER,
    headerTitle: HEADER_TITLES.ERROR
  },
};

/** 実行処理 で使用する phase ごとの情報 */
export const PHASE_INFO_FOR_ROUTINE = {
  [PHASE.RL_EXE]: {
    apiType: 'rl',
    monitorPhase: PHASE.RL_MONITOR,
  },
  [PHASE.RR_EXE]: {
    apiType: 'rr',
    monitorPhase: PHASE.RR_MONITOR
  },
  [PHASE.AIR_EXE]: {
    apiType: 'air',
    monitorPhase: PHASE.AIR_MONITOR
  },
  [PHASE.AIR_MONITOR]: {
    apiType: 'tmc',
    monitorPhase: PHASE.TMC_MONITOR,
  },
  [PHASE.PIPE_EXE]: {
    apiType: 'pipe',
    monitorPhase: PHASE.PIPE_MONITOR
  }
};

/** 実行監視画面で使用する phase ごとの情報 */
export const PHASE_INFO_FOR_MONITOR = {
  [PHASE.RL_MONITOR]: {
    nextPhase: PHASE.RR_EXE
  },
  [PHASE.RR_MONITOR]: {
    nextPhase: PHASE.AIR_EXE
  },
  [PHASE.TMC_MONITOR]: {
    nextPhase: PHASE.PIPE_EXE
  },
};

/** ルーチン実行またはルーチン結果確認が「異常終了」の際の async 情報 */
export const ASYNC_ERROR_INFO = {
  [error.WSP_160_AIR_VENT_FAILED]: {
    nextPhase: PHASE.AIR_BLEEDING_ERROR //フルード交換/エア抜き失敗表示
  },
  [error.WSP_160_BREAK_ABNORMAL_FAILED]: {
    nextPhase: PHASE.BRAKE_ERROR //ブレーキ異常表示
  },
  [error.WSP_160_PIPE_ABNORMAL_FAILED]: {
    nextPhase: PHASE.PIPE_ERROR //パイプ異常表示
  },
  [error.WSP_160_AIR_ENTERS_FAILED]: {
    nextPhase: PHASE.TEST_ERROR //エア混入/フルード漏れテスト失敗表示
  },
};